import AdvancedSearchTab from './AdvancedSearchTab';
import ChatBox from '../inbox/components/ChatBox';

const Search = () => {
  return (
    <>
      <div className="container mt-3">
        <AdvancedSearchTab />
      </div>
      <ChatBox/>
    </>
  );
};

export default Search;